import {delayHit, hitAlgolytics} from "@pg-mono/algolytics"; // we use this for unification process

import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const neighborhoodOffersViewHit = (viewType: ViewType, offerIds: number[]) => {
    const payload = {
        ...getTrackedSiteData(),
        view_type: viewType,
        offers_id: offerIds
    };
    neighborhoodOffersViewHitAlgolytics(payload);
};

export const neighborhoodOffersViewHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("neighborhood_offers_open", payload), 500);
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics"; // we use this for unification process

import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const neighborhoodOffersViewHit = (viewType: ViewType, offerIds: number[]) => {
    const payload = {
        ...getTrackedSiteData(),
        view_type: viewType,
        offers_id: offerIds
    };
    neighborhoodOffersViewHitAlgolytics(payload);
};

export const neighborhoodOffersViewHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("neighborhood_offers_open", payload), 500);
